import type { ReactNode } from "react";
import { AdminSidebar } from "./AdminSidebar";

interface AdminShellProps {
  readonly children: ReactNode;
}

export function AdminShell({ children }: AdminShellProps) {
  return (
    <main className="page-shell">
      <section className="admin-layout">
        <AdminSidebar />
        <div>{children}</div>
      </section>
    </main>
  );
}
